import { EnumsApiService } from '@services/enums.api.service';

import { SET_ENUMS, GET_ENUMS } from './enums.types';

export default {
  namespaced: true,

  state: {
    enums: {},
  },

  mutations: {
    [SET_ENUMS](state, payload) {
      state.enums = payload;
    },
  },

  actions: {
    async [GET_ENUMS]({ commit }) {
      commit(SET_ENUMS, await EnumsApiService.getEnums());
    },
  },

  getters: {
    messageStateEnum: ({ enums: { messageState } }) => messageState || [],
    jobStateEnum: ({ enums: { jobState } }) => jobState || [],
    jobSubStateEnum: ({ enums: { jobSubstate } }) => jobSubstate || [],
    basketStateEnum: ({ enums: { basketState } }) => basketState || [],
    jobOperationStateEnum: ({ enums: { jobOperation } }) => jobOperation || [],
    machineDrawerStateEnum: ({ enums: { machineDrawerState } }) => machineDrawerState || [],
    machineDrawerStateEnumByKey: ({ enums: { machineDrawerState } }) => {
      const res = {};
      (machineDrawerState || []).forEach((e) => {
        res[e.value] = e.name;
      });
      return res;
    },
    basketStateEnumByKey: ({ enums: { basketState } }) => {
      const res = {};
      (basketState || []).forEach((e) => {
        res[e.value] = e.name;
      });
      return res;
    },
  },
};
